import { Component, OnInit, Input, ChangeDetectionStrategy} from '@angular/core';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

@Component({ standalone: false,
  selector: 'irb-expando-link',
  templateUrl: './expando-link.component.html',
  styleUrls: ['./expando-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ExpandoLinkComponent implements OnInit {
  @Input() text: string;
  @Input() isOpen: boolean = false;
  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;

  constructor() { }

  ngOnInit(): void {
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }
}
